import { type Dispatch, type ReactNode, type SetStateAction } from 'react'

import { type BaseFilterValues } from '#hooks/useReportFilters'
import { getRangeOptions, type RangeKey } from '#utils/timeRanges'

import { FilterInput } from './adminFilters/FilterInput'
import { FilterRow } from './adminFilters/FilterRow'
import { FilterSelect } from './adminFilters/FilterSelect'
import { ScacTypeahead } from './ScacTypeahead'

interface ReportFilterControlsProps<T extends BaseFilterValues> {
  filters: T
  onChange: Dispatch<SetStateAction<T>> | ((filters: T) => void)
  children?: ReactNode
}

const ReportFilterControls = <T extends BaseFilterValues>({
  filters,
  onChange,
  children,
}: ReportFilterControlsProps<T>) => {
  const update = (partial: Partial<BaseFilterValues>) =>
    onChange({ ...filters, ...partial })

  return (
    <FilterRow>
      {children}
      <FilterSelect
        label="Time Range"
        value={filters.range}
        onChange={value => update({ range: value as RangeKey })}
        options={getRangeOptions()}
      />
      {filters.range === 'custom' ? (
        <>
          <FilterInput
            label="From"
            value={filters.customFrom}
            onChange={value => update({ customFrom: value })}
            type="datetime-local"
          />
          <FilterInput
            label="To"
            value={filters.customTo}
            onChange={value => update({ customTo: value })}
            type="datetime-local"
          />
        </>
      ) : null}
      <ScacTypeahead
        value={filters.scac}
        onChange={value => update({ scac: value })}
      />
    </FilterRow>
  )
}

export { ReportFilterControls }
